{
    "TeamsAuth_UserIntro": "Hallo **{}**,",
    "TeamsAuth_UserIntro_2": "Akixi for MS Teams vraagt toegang tot je Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Toestemming verlenen",
    "TeamsAuth_Authorise": "Autoriseer",
    "TeamsAuth_ConsentedMessage": "Admin Toestemming verleend, klik op Toestaan om verder te gaan",
    "TeamsAuth_AuthorisedMessage": "Toestemming verleend",
    "TeamsAuth_Decline": "Daling",
    "TeamsAuth_Error_Unknown": "Er is een onherkende fout opgetreden. Probeer het opnieuw. Als het probleem zich blijft voordoen, neem dan contact op met uw systeembeheerder.",
    "NAME": "TeamsAuth",
    "TeamsAuth_Authoriser_Select_Title": "Welke gebruikers wilt u synchroniseren vanuit uw Microsoft Entra Tenant?",
    "TeamsAuth_Authoriser_Select_Options_Tenant": "Alle toepasselijke gebruikers van Tenant",
    "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Alleen geselecteerde beveiligingsgroep(en)",
    "TeamsAuth_SecurityGroups_Loader_Title_1": "Beveiligingsgroepen ophalen",
    "TeamsAuth_SecurityGroups_Loader_Title_2": "Dit zal niet lang duren, we vragen nog even geduld...",
    "TeamsAuth_SecurityGroups_Title": "Selecteer uw beveiligingsgroepen",
    "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "Er zijn geen beveiligingsgroepen gevonden...",
    "TeamsAuth_SecurityGroups_SecurityGroup": "[ID: {}]",
    "TeamsAuth_SecurityGroups_Note": "Let op: Beveiligingsgroepen kunnen later worden bijgewerkt",
    "TeamsAuth_SecurityGroups_SyncAndClose": "Synchroniseren en sluiten",
    "TeamsAuth_SecurityGroups_NoSecurityGroups": "Synchroniseer de hele huurder"
}